import { red } from "@mui/material/colors";

// A brighter red than the `Unhealthy` dot colour (red[500]) so an emergency
// reads as its own signal rather than as a stale exchange.
export const emergencyColor: string = red.A400;

// Exchanges report `execution_mode: "Emergency"` on their uptime object.
// Compared case-insensitively so a backend casing change does not silently
// disable the highlight.
export const isEmergencyMode = (uptime?: {
  execution_mode?: string;
}): boolean => uptime?.execution_mode?.toLowerCase() === "emergency";
